import React from 'react';
import {
  Container, Tab, Row, Col, Nav,
} from 'react-bootstrap';
import Navbar from '../../../components/Navbar';
import Header from '../../../components/Header';
import DataDiri from './DataDiri';
import { ContainerHistori } from './styles';
import DaftarPartisipasi from './DaftarPartisipasi';

const HistoriPengajuanPartisipasi = () => (
  <>
    <Navbar />
    <Header />
    <Container>
      <ContainerHistori>
        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
          <Row>
            <Col sm={3}>
              <Nav variant="pills" className="flex-column">
                <Nav.Item>
                  <Nav.Link eventKey="first">Data Diri</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="second">Histori Partisipasi KUM</Nav.Link>
                </Nav.Item>
              </Nav>
            </Col>
            <Col sm={9}>
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <DataDiri />
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <DaftarPartisipasi />
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </ContainerHistori>
    </Container>
  </>
);

export default HistoriPengajuanPartisipasi;
